import { ElMessageBox } from 'element-plus'

interface AskOptions {
  /** Минимальная длина (бэкенд требует от 3 символов для ручных действий). */
  min?: number
  confirmText?: string
  placeholder?: string
}

/**
 * Запрашивает текст (причина, комментарий) у администратора.
 * Возвращает строку или null, если окно закрыли.
 */
export const askReason = async (
  title: string,
  message: string,
  options: AskOptions = {}
): Promise<string | null> => {
  const min = options.min === undefined ? 3 : options.min
  try {
    const result: any = await ElMessageBox.prompt(message, title, {
      confirmButtonText: options.confirmText || 'Подтвердить',
      cancelButtonText: 'Отмена',
      inputType: 'textarea',
      inputPlaceholder: options.placeholder || 'Причина',
      inputValidator: (value: string) =>
        (value || '').trim().length >= min || `Минимум ${min} символа`,
    })
    return String(result.value).trim()
  } catch (e) {
    return null
  }
}

/** Подтверждение без ввода. true, если администратор согласился. */
export const askConfirm = async (
  title: string,
  message: string,
  confirmText = 'Подтвердить'
): Promise<boolean> => {
  try {
    await ElMessageBox.confirm(message, title, {
      type: 'warning',
      confirmButtonText: confirmText,
      cancelButtonText: 'Отмена',
    })
    return true
  } catch (e) {
    return false
  }
}
